import { render } from "./FileSystem.vue?vue&type=template&id=fd944386&scoped=true&ts=true"
import script from "./FileSystem.vue?vue&type=script&lang=ts"
export * from "./FileSystem.vue?vue&type=script&lang=ts"

import "./FileSystem.vue?vue&type=style&index=0&id=fd944386&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd944386"]])

export default __exports__